import React from 'react'
import "./Footer.css";

function Footer() {
  return (
    <div className='footer'>
      <div className='version'>version 0.0.0.1 Beta</div>
      <h6 className='credit'>POWERED BY MVELIO</h6>
    </div>
  )
}

export default Footer